import { type TransformedAssortmentSkuLocationsItem } from '../../../../redux/assortment/schemas/get-assortment-sku-locations.schema';

const SEPARATOR = '::';

export const getRowId = (row: TransformedAssortmentSkuLocationsItem) => {
  return `${row.sku.id}${SEPARATOR}${row.location.id}`;
};

export const parseRowId = (rowId: string) => {
  const [skuId, locationId] = rowId.split(SEPARATOR);
  return { skuId, locationId };
};
